<app-alerts />

<app-dictionary-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)"
  [hiddenControls]="['slug']" />
